/* eslint-disable */

function disclosure(btn) {
 
    const open = () => btn.setAttribute('aria-expanded', true);

    const close = () => btn.setAttribute('aria-expanded', false);

    btn.onclick = e => {
        e.preventDefault();
        btn.getAttribute('aria-expanded') === 'true' ? close() : open();
    };
}

export default disclosure;